import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <div className="video-background">
        {/* Desktop video */}
        <video className="desktop-video" autoPlay loop muted playsInline>
          <source src="/videos/intro.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Mobile video */}
        <video className="mobile-video" autoPlay loop muted playsInline>
          <source src="/videos/Construction.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
      </div>

      <div className="hero-content">
        <h1 className="hero-title">
          e<span style={{ color: '#FB041C' }}>k</span>s construction
        </h1>

        {/* Responsive divider below */}
        <div className="hero-divider">
          <span className="divider-line"></span>
          <span className="divider-text">
            Feel the happiness in your Home
          </span>
          <span className="divider-line"></span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
